import type { MatchRanking } from "../../game/types";

const displayName = (snakeId: string): string => {
  if (snakeId === "player") return "你";
  const suffix = snakeId.match(/(\d+)$/)?.[1];
  return suffix ? `航迹 ${suffix}` : `航迹 ${snakeId}`;
};

const RankingRow = ({ ranking }: { readonly ranking: MatchRanking }) => (
  <li
    className="leaderboard-row"
    data-player={ranking.snakeId === "player"}
    data-snake-id={ranking.snakeId}
  >
    <span className="leaderboard-rank" aria-label={`第 ${ranking.rank} 名`}>
      {ranking.rank}
    </span>
    <span className="leaderboard-marker" aria-hidden="true">
      {ranking.snakeId === "player" ? "◆" : "◇"}
    </span>
    <span className="leaderboard-name">{displayName(ranking.snakeId)}</span>
    <strong className="leaderboard-length">{Math.round(ranking.length)}</strong>
  </li>
);

export function Leaderboard({
  rankings,
}: {
  readonly rankings: readonly MatchRanking[];
}) {
  const alive = rankings.filter((ranking) => ranking.alive);
  const topFive = alive.slice(0, 5);
  const player = alive.find((ranking) => ranking.snakeId === "player");
  const desktopRows =
    player && !topFive.some((ranking) => ranking.snakeId === "player")
      ? [...topFive, player]
      : topFive;

  return (
    <aside className="leaderboard" aria-label="实时长度排行榜">
      <div className="leaderboard-heading">
        <span>实时长度榜</span>
        <span>长度</span>
      </div>
      <ol className="leaderboard-list leaderboard-list-desktop">
        {desktopRows.map((ranking) => (
          <RankingRow key={ranking.snakeId} ranking={ranking} />
        ))}
      </ol>
      <details className="leaderboard-mobile">
        <summary aria-label="展开实时长度排行榜">
          {player ? (
            <>
              <span>你的排名</span>
              <strong>
                {player.rank}/{alive.length} · {Math.round(player.length)}
              </strong>
            </>
          ) : (
            <>
              <span>你的排名</span>
              <strong>等待重新加入</strong>
            </>
          )}
        </summary>
        <ol className="leaderboard-list">
          {alive.map((ranking) => (
            <RankingRow key={ranking.snakeId} ranking={ranking} />
          ))}
        </ol>
      </details>
    </aside>
  );
}
